import {SvgInjector}      from './modules/svgInjector';
import {Parallax}         from './modules/parallax';
import {ImagePopUp}       from './modules/imagePopUp';
import {Carousels}        from './modules/carousels';
import {MiniGallery}      from './modules/miniGallery';
import {Cookies}          from './modules/cookies';
import {ScrollTo}         from './modules/scrollTo';
import {GoogleMaps}       from './modules/googleMaps';
import {Video}            from './modules/video';
import {Validator}        from './modules/validator';
import {SidePanel}        from './modules/sidePanel';
import {SwiperSlider}     from './modules/swiperSlider';
import {ScrollActive}     from './modules/scrollActive';
import {Map}              from './modules/map';
import {TagTracking}      from './modules/gtag';
import {ShowContact}      from './modules/showContact';
import {YtVideo}          from './modules/ytVideo';
import {ShowItem}         from './modules/showItem';
window.Swiper = require("../../../../node_modules/swiper/dist/js/swiper");
// import {Load}             from './modules/load';

var svgInjector       = new SvgInjector();
var parallax          = new Parallax();
var imagePopUp        = new ImagePopUp();
var carousels         = new Carousels();
var miniGallery       = new MiniGallery();
var cookies           = new Cookies();
var scrollTo          = new ScrollTo();
var googleMaps        = new GoogleMaps();
var video             = new Video();
var validator         = new Validator();
var sidePanel         = new SidePanel();
var swiper            = new SwiperSlider();
var scrollActive      = new ScrollActive();
var map               = new Map();
// var load              = new Load();
var tracking          = new TagTracking();
var showContact       = new ShowContact();
var ytVideo           = new YtVideo();
var showItem          = new ShowItem();

class Main{
  constructor(node_env){
    this.node_env = node_env;
    this.sections = $('.cms-section');
}
  bootstrap(callback){
    var $sections = $(this.sections);
    this.modules($sections);
    this.responsiveModules($sections);
    callback();
  }

  modules($sections){
    parallax.init($sections);
    svgInjector.init();
    imagePopUp.init();
    carousels.init();
    miniGallery.init();
    cookies.init();
    scrollTo.init();
    googleMaps.init();
    video.init();
    validator.init();
    sidePanel.init();
    swiper.init();
    scrollActive.init();
    map.init();
    // load.init();
    tracking.init();
    // showContact.init();
    ytVideo.init();
    showItem.init();
  }

  responsiveModules($sections){
    $(window).resize(function(){
      parallax.init($sections);
      carousels.init();
      miniGallery.init();
    });

    $(window).scroll(function(){
      $('.video-player').each(function(id, videoPlayer){
        if( $(videoPlayer).visible(true) ){
          video.play($(videoPlayer));
        }else{
          video.stop($(videoPlayer));
        }
      });
    });
  }
}


$(window).load(function(){
  var main = new Main('development');
  main.bootstrap(function(){
    $('#page-overlay').fadeOut(800);
  });
});
